/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList';
import themeConfig from '@/../themeConfig.js';
import colors from '@/../themeConfig.js';

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
    id: 0,          // From Auth
    full_name: '-', // From Auth
    position: '-',
    about: 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
    profile_picture: require('@assets/images/portrait/small/blank-profile.jpg'), // From Auth
    status: 'online',
    userRole: 'admin',
};

const appDefaults = {
    auth: {
        api_login_url: '/api/v1/auth/login',
        api_logout_url: '/api/v1/auth/logout',
        api_refresh_url: '/api/v1/auth/refresh',
        login_url: '/login',
        type: 'credentials',
    },
};

const userInfoLocalStorage = JSON.parse(localStorage.getItem('userInfo')) || {};
const ImpersonatorInfoLocalStorage = JSON.parse(localStorage.getItem('impersonator')) || {};
const appInfoLocalStorage = JSON.parse(localStorage.getItem('appInfo')) || {};

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
    let userInfo = {};

    // Update property in user
    Object.keys(userDefaults).forEach((key) => {
        // If property is defined in localStorage => Use that
        userInfo[key] = userInfoLocalStorage[key] ? userInfoLocalStorage[key] : userDefaults[key];
    });

    // Include properties from localStorage
    Object.keys(userInfoLocalStorage).forEach((key) => {
        if (userInfo[key] === undefined && userInfoLocalStorage[key] != null) {
            userInfo[key] = userInfoLocalStorage[key];
        }
    });

    return userInfo;
};
const getImpersonator = () => {
    let userInfo = {};

    // Update property in user
    if (!ImpersonatorInfoLocalStorage.length) {
        return userInfo;
    }
    Object.keys(userDefaults).forEach((key) => {
        // If property is defined in localStorage => Use that
        userInfo[key] = ImpersonatorInfoLocalStorage[key] ? ImpersonatorInfoLocalStorage[key] : userDefaults[key];
    });

    // Include properties from localStorage
    Object.keys(ImpersonatorInfoLocalStorage).forEach((key) => {
        if (userInfo[key] === undefined && ImpersonatorInfoLocalStorage[key] != null) {
            userInfo[key] = ImpersonatorInfoLocalStorage[key];
        }
    });

    return userInfo;
};

const getAppInfo = () => {
    let appInfo = {};

    // Update property in user
    Object.keys(appDefaults).forEach((key) => {
        // If property is defined in localStorage => Use that
        appInfo[key] = appInfoLocalStorage[key] ? appInfoLocalStorage[key] : appDefaults[key];
    });

    // Include properties from localStorage
    Object.keys(appInfoLocalStorage).forEach((key) => {
        if (appInfo[key] === undefined && appInfoLocalStorage[key] != null) {
            appInfo[key] = appInfoLocalStorage[key];
        }
    });

    return appInfo;
};

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser: getUserInfo(),
    impersonator: getImpersonator(),
    AppInfo: getAppInfo(),
    bodyOverlay: false,
    isVerticalNavMenuActive: true,
    mainLayoutType: themeConfig.mainLayoutType || 'vertical',
    navbarSearchAndPinList: navbarSearchAndPinList,
    reduceButton: themeConfig.sidebarCollapsed,
    verticalNavMenuWidth: 'default',
    verticalNavMenuItemsMin: false,
    scrollY: 0,
    starredPages: navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
    theme: themeConfig.theme || 'light',
    themePrimaryColor: colors.primary,
    priorityEditModal:{
        open: false,
        data: null
    },
    actionRequiredTimeLineModal:{
        open: false,
    },
    priorityOptions: [],

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
};

export default state;
